export default __webpack_public_path__ + "static/media/alert_icon_correct.140510bf.svg";